import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { NServices,  ServiceClient } from "src/app/web-api-client";

@Component({
  selector: 'app-service-creation',
  templateUrl: './service-creation.component.html',
  styleUrls: ['./service-creation.component.scss']
})
export class ServiceCreationComponent implements OnInit  {

  public isLoaded = true;
  public services: NServices[];

  public onClose = new Subject<boolean>();
   Form: FormGroup;

  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal,public client:ServiceClient ) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.Form = this.fb.group({
      serviceName: ['', Validators.required],
      uri: ['', Validators.required],
      yri: ['', Validators.required],
      isActive: [null, Validators.required]
    });
  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }

  onSubmit() {
    if (this.Form.valid) {

      let service =new NServices();

      service.idService = 0;
      service.serviceName = this.Form.value.serviceName;
      service.uri = this.Form.value.uri;
      service.yri = this.Form.value.yri;
      service.isActive = this.Form.value.isActive;
      service.serviceTemplate = '';

      this.client.create(service).subscribe((user) => {
        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

}
